import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.managers.rank;

export const managersRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
